export const USER = 'USER';
export const PUSH_NOTIFICATIONS = 'PUSH_NOTIFICATIONS';
